import {Component, ViewEncapsulation} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {ArticleUtils} from "../../../common/utils/articleutils";
import {TransferState} from "../../modules/transfer-state/transfer-state";
import {CostGuideUtils} from "../../../common/utils/costguideutils";
import {LoopBackConfig} from "../shared/sdk/lb.config";
import {API_VERSION, BASE_URL} from "../shared/base.url";
import {ReplaySubject} from "rxjs/ReplaySubject";
import {routeAnimation} from "../shared/animations/route.animation";

@Component({
  templateUrl: './category.component.html',
  styleUrls: [ './category.component.scss' ],
  selector: 'categoryComponent',
  encapsulation: ViewEncapsulation.None,
/*  animations: [ routeAnimation ],
  host: {
    '[@routeAnimation]': 'true',
    '[style.display]': "'block'",
    '[style.position]': "'absolute'",
    '[style.left]' : "'0'",
    '[style.right]' : "'0'"
  }, */
})

export class CategoryComponent {

  protected categories: object = {
    'personal-finance': {category: 'Personal Finance', costGuideUrl: '/costs/pool-all-install-build', cacheArticles: 'personalFinanceArticles'},
    'business': {category: 'Business', costGuideUrl: '/costs/security-video-surveillance-install', cacheArticles: 'businessArticles'},
    'economy': {category: 'The Economy', costGuideUrl: '/costs/water-heating-electric-install', cacheArticles: 'economyArticles'},
    'real-estate': {category: 'Real Estate', costGuideUrl: '/costs/roofing-all-install-replace', cacheArticles: 'realEstateArticles'}
  };

  public articles: Array<object> = [];
  public articlesTopSection: Array<object> = [];
  public insuranceCostGuideTopSection: object;
  public homeImprovementCostGuideTopSection: object;
  public previousBlocks: Array<object> = [];
  protected previousBlocksReplaySubject = new ReplaySubject();
  protected previousBlocksOffset: number = 3;

  public category: string;
  public categoryId: string;

  constructor(protected route: ActivatedRoute,
              protected articleUtils: ArticleUtils,
              protected cache: TransferState,
              protected costGuideUtils: CostGuideUtils){

    this.categoryId = route.routeConfig.path;
    this.category = this.categories[route.routeConfig.path].category;

    let homeImprovementCostGuideURL = this.categories[route.routeConfig.path].costGuideUrl;
    let sectionArticlesCache = this.categories[route.routeConfig.path].cacheArticles;

    LoopBackConfig.setBaseURL(BASE_URL);
    LoopBackConfig.setApiVersion(API_VERSION);

    this.renderHomeArticlesTopSection(sectionArticlesCache);
    this.renderCostGuidesTopSection(homeImprovementCostGuideURL);

    //render a new block and clear infinite scroll:
    this.previousBlocksOffset = 0;
    this.previousBlocks = [];
    this.previousBlocksReplaySubject.complete();
    this.previousBlocksReplaySubject = new ReplaySubject();

    this.previousBlocksReplaySubject.subscribe((offset: number) => {

      let blockObject = {
        articles: null
      };

      this.articleUtils.loadPreviousArticlesByCategory(this.categoryId, offset, 3)
        .subscribe((articles: Array<object>) => {

          let cache = this.cache;

          if(articles != null && articles.length > 0) {

            articles.forEach(function(element){
              cache.set(element['url'], element);
            });

            blockObject.articles = articles;
            this.previousBlocks.push(blockObject);
          }
        })
    });
  }

  protected renderHomeArticlesTopSection(sectionArticlesCache: string): void {

    let _that = this;

    let articlesTopSectionCache = this.cache.get(sectionArticlesCache);
    if(articlesTopSectionCache != null) {
      this.articlesTopSection = articlesTopSectionCache;
    } else {
      this.articleUtils.loadSectionArticles(this.categoryId, 3, []).subscribe((articles: Array<object>) => {
        this.articlesTopSection = articles;
        articles.forEach(function(element){
          _that.cache.set(element['url'], element);
        });
        _that.cache.set(sectionArticlesCache, articles);
      });
    }
  }

  protected renderCostGuidesTopSection(homeImprovementCostGuideURL: string): void {

    let homeImprovementCostGuideTopSectionCache = this.cache.get('homeImprovementCostGuideTopSection');
    if(homeImprovementCostGuideTopSectionCache != null) {
      this.homeImprovementCostGuideTopSection = homeImprovementCostGuideTopSectionCache;
    } else {
      this.costGuideUtils.loadCostGuide(homeImprovementCostGuideURL).subscribe((costGuide: object) => {
        this.homeImprovementCostGuideTopSection = costGuide;
        this.cache.set(costGuide['url'], costGuide);
        this.cache.set('homeImprovementCostGuideTopSection', costGuide);
      });
    }

    let insuranceCostGuidesTopSectionCache = this.cache.get('insuranceCostGuideTopSection');
    if(insuranceCostGuidesTopSectionCache != null) {
      this.insuranceCostGuideTopSection = insuranceCostGuidesTopSectionCache;
    } else {
      this.costGuideUtils.loadCostGuideByVertical(2, 1).subscribe((costGuides: Array<object>) => {

        let costGuide = costGuides[0];

        this.insuranceCostGuideTopSection = costGuide;
          this.cache.set(costGuide['url'], costGuide);
        this.cache.set('insuranceCostGuideTopSection', costGuide);
      });
    }
  }

  public renderMoreContent() {
    this.previousBlocksOffset += 3;
    this.previousBlocksReplaySubject.next(this.previousBlocksOffset);
  }

}



// WEBPACK FOOTER //
// ./src/app/category/category.component.ts